import { Layout, Loading } from '@/components';
import { DevTools } from '@/features/dev-tools/_components/DevTools';
import {
  PAGE_LAYOUT_MIN_WIDTH,
  PAGE_LAYOUT_SIDEBAR_WIDTH,
  PAGE_LAYOUT_SIDEBAR_WIDTH_COLLAPSED,
  isDevMode,
} from '@/utils';
import { type FC, type ReactNode, Suspense, useRef, useState } from 'react';
import { Outlet } from 'react-router';
import { PageSidebar } from './PageSidebar';

type Props = { rightSider?: ReactNode };

export const PageLayout: FC<Props> = ({ rightSider }) => {
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const contentRef = useRef<HTMLElement | null>(null);

  return (
    <Layout style={{ minWidth: PAGE_LAYOUT_MIN_WIDTH }}>
      <PageSidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <Layout
        style={{
          marginLeft: collapsed
            ? PAGE_LAYOUT_SIDEBAR_WIDTH_COLLAPSED
            : PAGE_LAYOUT_SIDEBAR_WIDTH,
        }}
      >
        <Layout.Content
          ref={contentRef}
          style={{ height: '100vh', overflowY: 'auto' }}
        >
          <Suspense fallback={<Loading />}>
            <Outlet />
            {isDevMode() && <DevTools />}
          </Suspense>
        </Layout.Content>
      </Layout>
      {rightSider}
    </Layout>
  );
};
